module.exports = __webpack_public_path__ + "img/68_23.30696f83.png";